// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GXoyc","header":"styles_header__B6AfJ","body":"styles_body__Gz1eI"};